import { render, staticRenderFns } from "./UnitProductCardFeatured.vue?vue&type=template&id=64405fbd&scoped=true"
import script from "./UnitProductCardFeatured.vue?vue&type=script&lang=js"
export * from "./UnitProductCardFeatured.vue?vue&type=script&lang=js"
import style0 from "./UnitProductCardFeatured.vue?vue&type=style&index=0&id=64405fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64405fbd",
  null
  
)

export default component.exports